export const USERNAME_MAX_LENGTH = 20;
